import TextContent from '../textContent/textContent';
import React from 'react';
import { withTranslation, WithTranslation } from 'react-i18next';

const Partners = (props: WithTranslation) => {
    const { t } = props;
    const descriptionCta = (
        <a
            className="standalone-link standalone-link--large"
            target="_blank"
            rel="noreferrer"
            href={t('partners_cta_destination')}
        >
            {t('partners_cta_title')}
        </a>
    );

    return (
        <TextContent
            description="partners_description"
            title="partners_title"
            descriptionCTAComponent={descriptionCta}
        />
    );
};

export default withTranslation()(Partners);
